import { booleanAttribute } from "#ce/utils/props";

export const props = Object.freeze({
  open: booleanAttribute(),
  /**
   * The URL to use for the content generation.
   * @type {String}
   */
  url: {
    type: String,
    required: true,
  },
  /**
   * Sends the current content to the API as generation input (the field menu's
   * interaction-preset items). Absent, the server generates from the field
   * parameters alone.
   * @type {Boolean|String}
   */
  sendOriginalContent: booleanAttribute(),
  /**
   * The initial content value.
   * @type {String}
   */
  modelValue: {
    type: String,
    default: "",
  },
});
